<template>
  <nav class="twcs-relative twcs-inline-flex twcs-shadow-sm twcs--space-x-px" aria-label="Pagination">
    <template v-for="link in linksComputed" :key="link.label">
      <a
        v-if="link.url !== null && !link.active"
        @click.prevent="$emit('pagination-link-clicked', link.url)"
        href="#"
        :class="[link.classes,
          'twcs-relative twcs-items-center twcs-px-4 twcs-py-2 twcs-border twcs-border-gray-300 twcs-bg-white twcs-text-base twcs-font-medium twcs-text-gray-700',
          'hover:twcs-bg-kctcs-navy-500 hover:twcs-text-white focus-visible:twcs-bg-kctcs-navy-500 focus-visible:twcs-text-white']"
      >
        <template v-if="typeof link.label === 'string' && link.label.includes('Prev')">
          <span class="twcs-sr-only">Previous</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="twcs-h-5 twcs-w-5" style="fill: none;" aria-hidden="true" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </template>
        <template v-else-if="typeof link.label === 'string' && link.label.includes('Next')">
          <span class="twcs-sr-only">Next</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="twcs-h-5 twcs-w-5" style="fill: none;" aria-hidden="true" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </template>
        <template v-else>
          {{ link.label }}
        </template>
      </a>
      <span
        v-else
        :class="[link.active ? 'twcs-text-white twcs-bg-gray-400' : 'twcs-text-gray-700 twcs-bg-white', link.classes, 'twcs-relative twcs-items-center twcs-px-4 twcs-py-2 twcs-border twcs-text-base twcs-font-medium twcs-border-gray-300']"
      >
        <template v-if="typeof link.label === 'string' && link.label.includes('Prev')">
          <span class="twcs-sr-only">Previous</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="twcs-h-5 twcs-w-5" style="fill: none;" aria-hidden="true" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </template>
        <template v-else-if="typeof link.label === 'string' && link.label.includes('Next')">
          <span class="twcs-sr-only">Next</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="twcs-h-5 twcs-w-5" style="fill: none;" aria-hidden="true" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </template>
        <template v-else>
          <span class="twcs-hidden sm:twcs-block">
            {{ link.label }}
          </span>
          <span class="twcs-block sm:twcs-hidden">
            {{ link.label }}
            <template v-if="linksComputed.length > 7">
              of {{ linksComputed[linksComputed.length - 2].label }}
            </template>
          </span>
        </template>
      </span>
    </template>
  </nav>
</template>

<script setup>
import { computed } from 'vue';

let props = defineProps({
	links: {
		type: Array,
		default: () => [],
	},
});

defineEmits(['pagination-link-clicked']);

let linksComputed = computed(() => {
	if(props.links.length <= 7) {
		return props.links.map((link) => {
			return { ...link, classes: 'twcs-inline-flex'};
		});
	} else {
		let hiddenIndices = [];
		let firstNullIndex = props.links.findIndex((link) => {
			return link.label === '...';
		});
		if(firstNullIndex === 3) {
			let secondNullIndex = props.links.slice(firstNullIndex+1).findIndex((link) => {
				return link.label === '...';
			});
			if(secondNullIndex !== -1) {
				hiddenIndices.push(4, 5, secondNullIndex - 1, secondNullIndex - 2);
			} else {
				hiddenIndices.push(4, 5, 6, 7);
			}
		} else {
			hiddenIndices.push(firstNullIndex - 4, firstNullIndex - 3, firstNullIndex - 2, firstNullIndex - 1);
		}
		return props.links.map((link, index) => {
			if(hiddenIndices.includes(index)) {
				return { ...link, classes: 'twcs-hidden lg:twcs-inline-flex'};
			}
			if(index !== 0 && index !== props.links.length - 1 && !link.active) {
				return { ...link, classes: 'twcs-hidden sm:twcs-inline-flex'};
			}
			return { ...link, classes: 'twcs-inline-flex'};
		});
	}
});
</script>
